import { BowlMixOutlineIcon } from './BowlMixOutlineIcon';

/**
 * author: Simran
 * id 3C547C40-FF5E-4BB6-B45E-2B26AD990B20
 * name bowl-mix-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bowl-mix-outline.svg
 * tags
 * - Food / Drink 
 */
export const MixingBowlOutlineIcon = BowlMixOutlineIcon;
export default MixingBowlOutlineIcon